/** Wallet credit included each billing month, in minor units of the subscription currency. Does not roll over */
export const INCLUDED_WALLET_CREDIT_CENTS = {
    Pro: {
        USD: 1000, CAD: 1000, NZD: 1000, AUD: 1000, GBP: 500, EUR: 500,
    },
    Essentials: {
        USD: 500, CAD: 500, NZD: 500, AUD: 500, GBP: 200, EUR: 200,
    },
};
/** Purchased credit expires this many months after purchase */
export const PURCHASED_WALLET_CREDIT_EXPIRY_MONTHS = 12;
/** Preset amounts offered in the UI, in major units. Any whole amount in the min/max range is allowed */
export const WALLET_AMOUNT_PRESETS = [10, 25, 50, 100];
export const WALLET_THRESHOLD_PRESETS = [5, 10, 25];
export const WALLET_MIN_CENTS = 500;
export const WALLET_MAX_CENTS = 20000;
export var WalletEntryType;
(function (WalletEntryType) {
    /** Monthly plan credit */
    WalletEntryType["INCLUDED"] = "included";
    WalletEntryType["PURCHASE"] = "purchase";
    WalletEntryType["AUTO_RECHARGE"] = "auto_recharge";
    /** One per connected call, can take the balance below zero */
    WalletEntryType["SPEND"] = "spend";
    /** Manual correction, either sign. Positive ones expire like purchased credit */
    WalletEntryType["ADJUSTMENT"] = "adjustment";
    /** What was left of a credit when it expired, written by the hourly cron */
    WalletEntryType["EXPIRY"] = "expiry";
})(WalletEntryType || (WalletEntryType = {}));
export const WALLET_CREDIT_TYPES = [WalletEntryType.INCLUDED, WalletEntryType.PURCHASE, WalletEntryType.AUTO_RECHARGE];
//# sourceMappingURL=wallet.js.map